var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBevoBreakingFluid48(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2,17.2l-1.7-1.7c-4.7,4.7-4.7,12.3,0,17l1.7-1.7C13.5,27,13.5,21,17.2,17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,19.2l-2.6,5.2c-0.2,0.4-0.3,0.9-0.3,1.3c0,1.6,1.3,3,3,3c1.6,0,3-1.3,3-3c0-0.5-0.1-0.9-0.3-1.3L24,19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,15.5c-4.7,0-8.5,3.8-8.5,8.5c0,4.7,3.8,8.5,8.5,8.5c4.7,0,8.5-3.8,8.5-8.5C32.5,19.3,28.7,15.5,24,15.5 M24,30.7 c-3.7,0-6.7-3-6.7-6.7c0-3.7,3-6.7,6.7-6.7c3.7,0,6.7,3,6.7,6.7C30.7,27.7,27.7,30.7,24,30.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5,15.5l-1.7,1.7c3.7,3.8,3.7,9.8,0,13.6l1.7,1.7C37.2,27.8,37.2,20.2,32.5,15.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBevoBreakingFluid48);
export default __webpack_public_path__ + "static/media/ic_bevo_breaking-fluid_48.b2a20ece579538c7e59323d123c45eb1.svg";
export { ForwardRef as ReactComponent };